import React, { useState, useEffect } from "react";
import HeaderSales from "./common/HeaderSales"; // Kept import, but removed from view
import Footer from "./common/Footer";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import * as Constants from "./Constants/index";
import swal from "sweetalert";
import ResponsivePagination from "react-responsive-pagination";
import { saveAs } from "file-saver";
import Oval from "./../loader/CircleLoade";
import { useFormik } from "formik";
// Added Sidebar Import
import Sidebar from "./common/Sidebar";

export default function ApprovedPlumber() {
  const [results, setResults] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchRecord, setSearchRecord] = useState();
  const [limit] = useState("10");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const buildFilterQuery = (data = {}) => {
    const params = new URLSearchParams();

    if (data.mobile) {
      params.append("mobile", data.mobile);
    }

    if (data.startDate && data.endDate) {
      params.append("start", moment(data.startDate).format("YYYY-MM-DD HH:mm:ss"));
      params.append("end", moment(data.endDate).format("YYYY-MM-DD 23:59:59"));
    }

    return params.toString() ? `&${params.toString()}` : "";
  };

  useEffect(() => {
    getEnrollmentData(
      {
        mobile: "",
        startDate: "",
        endDate: "",
      },
      1
    );
  }, []);

  const searchFormik = useFormik({
    initialValues: {
      mobile: "",
      startDate: "",
      endDate: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.mobile) {
        if (data.mobile.length < 10) {
          errors.mobile = "Mobile must be in 10 digits.";
        }
      }
      if (data.startDate === "" && data.endDate !== "") {
        errors.startDate = "Please select date";
      }
      if (data.startDate !== "" && data.endDate === "") {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "End date should be greater than start date";
      }
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getEnrollmentData(data, 1);
      setFilterData(data);
    },
  });

  const getEnrollmentData = async (data, pageNum) => {
    let token = localStorage.getItem("token");
    const filterQuery = buildFilterQuery(data);
    try {
      setLoading(true);
      await axios
        .get(
          `${Constants.baseUrl}reports/users/list?userType=MEMBER${filterQuery}&sortBy=createDateTime&status=APPROVED&sortAsc=true&limit=${limit}&page=${pageNum}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          }
        )
        .then((res) => {
          if (res.status === 201) {
            if (res.data.code === 10001 && res.data.output) {
              setResults(res.data.output.results);
              setTotalPages(res.data.output.totalPages);
              setSearchRecord(res.data.output.results);
              console.log(
                "res.data.output.results....",
                res.data.output.results
              );
              setLoading(false);
            } else if (res.data.code === 12002 && res.data.output) {
              setLoading(false);
              setTotalPages(0);
              setResults(null);
            } else {
              swal({
                text: res.data.msg,
                icon: "error",
                timer: 2000,
                buttons: false,
              });
            }
          } else {
            swal({
              text: res.data.msg,
              icon: "error",
              timer: 2000,
              buttons: false,
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const download = (data) => {
    let token = localStorage.getItem("token");
    const filterQuery = buildFilterQuery(data);
    try {
      setLoading(true);
      axios
        .get(
          Constants.baseUrl +
          `reports/download/userReport?userType=MEMBER${filterQuery}&status=APPROVED`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
            responseType: "blob", // Set the responseType to 'blob'
          }
        )
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            const fileData = new Blob([res.data], { type: "text/csv" });
            saveAs(fileData, "APPROVED Report.csv");
          } else {
            swal({
              text: res.data.msg,
              // icon: 'error',
              timer: 2000,
              buttons: false,
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };
  

  const handleReset =()=>{
    searchFormik.resetForm();
    setCurrentPage(1)
    const defaulfilter= {
      mobile:'',
      startDate:"",
      endDate:"",
    }
    setFilterData(defaulfilter)
    getEnrollmentData(defaulfilter,1)
  }
  return (
    <>
      {loading ? <Oval /> : null}

      {/* --- SIDEBAR LAYOUT WRAPPER START --- */}
      <div style={{ display: 'flex', width: '100%', minHeight: '100vh', backgroundColor: '#f5f7fa' }}>

        {/* Sidebar Fixed Left */}
        <div style={{ flexShrink: 0 }}>
          <Sidebar />
        </div>

        {/* Content Area Resizable Right */}
        <div style={{ flex: 1, padding: '20px', overflowX: 'auto', display: 'flex', flexDirection: 'column' }}>

          <div className="all-single-blog rpt" style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', flex: 1 }}>

            {/* Tabs */}
            <div className="row">
              <div className="col-md-12 tab mb-20">
                <ul className="nav nav-tabs" role="tablist">
                  <li role="presentation" className="active">
                    <Link to="#Section1" role="tab" data-toggle="tab">
                      Report
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Form */}
            <form onSubmit={searchFormik.handleSubmit}>
              <div className="row clearfix mb-15">
                <div className="col-md-4 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>Mobile No. </label>
                    <input
                      className="form-control reset"
                      type="text"
                      placeholder="Mobile No."
                      id="mobile"
                      value={searchFormik.values.mobile}
                      onChange={(e) => {
                        const numericValue = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        searchFormik.handleChange({
                          target: {
                            name: "mobile",
                            value: numericValue,
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <button
                      type="submit"
                      className="btn login_btn"
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        padding: "5px 18px",
                        fontSize: "12px",
                        borderRadius: "3px",
                        minWidth: "120px",
                      }}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      onClick={handleReset}
                      className="btn"
                      style={{
                        backgroundColor: "#737373",
                        color: "white",
                        padding: "5px 18px",
                        fontSize: "12px",
                        borderRadius: "3px",
                        minWidth: "120px",
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>From Date </label>
                    <DatePicker
                      id="startDate"
                      selected={
                        searchFormik.values.startDate
                          ? new Date(searchFormik.values.startDate)
                          : null
                      }
                      onChange={(date) =>
                        searchFormik.setFieldValue("startDate", date)
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showYearDropdown
                      showMonthDropdown
                      autoComplete="off"
                      scrollableYearDropdown
                    />
                  </div>
                  {errors.fromDate && (
                    <div className="error-message">{errors.fromDate}</div>
                  )}
                </div>
                <div className="col-md-4 col-sm-12 col-xs-12">
                  <div className="form-group has-float-label style-two">
                    <label>To Date </label>
                    <DatePicker
                      id="endDate"
                      selected={
                        searchFormik.values.endDate
                          ? new Date(searchFormik.values.endDate)
                          : null
                      }
                      onChange={(date) =>
                        searchFormik.setFieldValue("endDate", date)
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showYearDropdown
                      showMonthDropdown
                      autoComplete="off"
                      scrollableYearDropdown
                      maxDate={new Date()}
                    />
                  </div>
                  {errors.toDate && (
                    <div className="error-message">{errors.toDate}</div>
                  )}
                </div>
              </div>
            </form>

            {/* Table Container */}
            <div className="row">
              <div className="col-md-12">
                <div className="carrd1" style={{ marginTop: '20px' }}>
                  <div className="card-header card-header-warning" style={{ backgroundColor: '#28a745', color: 'white', padding: '10px 15px', borderRadius: '4px 4px 0 0' }}>
                    <h4 className="card-title" style={{ margin: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>APPROVED Report</span>
                      {searchRecord === null ? (
                        ""
                      ) : (
                        <Link
                          to="#"
                          className="pull-right btn btn-sm btn-light"
                          style={{ color: '#28a745', fontWeight: 'bold' }}
                          onClick={() => download(searchFormik.values)}
                        >
                          <i className="fa fa-file-excel-o"></i> Export
                        </Link>
                      )}
                    </h4>
                  </div>

                  <div className="card-body table-responsive" style={{ border: '1px solid #ddd', borderTop: 'none' }}>
                    <table
                      className="table table-striped mb_01"
                      id="table-to-xls"
                    >
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Member Name</th>
                          <th>Member Mobile</th>
                          <th>Registration Date</th>
                          <th>RegisterType</th>
                          <th>Registration Id</th>
                          <th>work Address1</th>
                          <th>work Address2</th>
                          <th>State</th>
                          <th>District</th>
                          <th>City</th>
                          <th>Pincode</th>
                          <th>Email ID</th>
                          <th>Aadhar Number</th>
                          <th>MobileNumberLinkedWithAadhar</th>
                          <th>AadharFrontImage</th>
                          <th>AadharBackImage</th>
                          <th>Pan Number</th>
                          <th>Upi Id</th>
                          <th>Ifsc</th>
                          <th>Bank Name</th>
                          <th>Bank Account No</th>
                          <th>Holder Name</th>
                          <th>Branch Name</th>
                          <th>Sales Executive Name</th>
                          <th>Sales Executive Code</th>
                          <th>Sales Executive Mobile</th>
                          <th>Sales Executive Cluster</th>
                          <th>Sales Executive Territory</th>
                          <th>Sales Executive Zone</th>
                          <th>Sales Head Name</th>
                          <th>Sales Head Code</th>
                          <th>Sales Head Mobile</th>
                          <th>Sales Head Cluster</th>
                          <th>Sales Head Territory</th>
                          <th>Sales Head Zone</th>
                          <th>RO Name</th>
                          <th>ZO Name</th>
                          <th>Approval/Rejection Date</th>
                          <th>Status</th>
                          <th>TotalEarnedPoints</th>
                          <th>TotalRedeemedPoints</th>
                          <th>BalancePoints</th>
                          <th>FirstScanDate</th>
                          <th>RejectionReason</th>
                          <th>Pan Image</th>
                          <th>Firm Name</th>
                          <th>activeStatus</th>
                        </tr>
                      </thead>
                      {searchRecord == null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="48"
                              style={{
                                textAlign: "center",
                                fontSize: "16px",
                                padding: '20px'
                              }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {results &&
                            results.map((item, index) => {
                              const serialNumber = (currentPage - 1) * limit + index + 1;
                              return (
                                <tr key={index}>
                                  <td>{serialNumber}</td>
                                  <td>{item[0]}</td>
                                  <td>{item[1]}</td>
                                  <td>{item[2]}</td>
                                  <td>{item[3]}</td>
                                  <td>{item[4]}</td>
                                  <td>{item[5]}</td>
                                  <td>{item[6]}</td>
                                  <td>{item[7]}</td>
                                  <td>{item[8]}</td>
                                  <td>{item[9]}</td>
                                  <td>{item[10]}</td>
                                  <td>{item[11]}</td>
                                  <td>{item[12]}</td>
                                  <td>{item[13]}</td>
                                  <td>
                                    {item[14] && (
                                      <button
                                        type="button"
                                        onClick={() => openImageModal(item[14])}
                                        style={{
                                          color: "#0d6efd",
                                          textDecoration: "underline",
                                          background: "transparent",
                                          border: "none",
                                          padding: 0,
                                          cursor: "pointer",
                                          font: "inherit",
                                        }}
                                      >
                                        View
                                      </button>
                                    )}
                                  </td>
                                  <td>
                                    {item[15] && (
                                      <button
                                        type="button"
                                        onClick={() => openImageModal(item[15])}
                                        style={{
                                          color: "#0d6efd",
                                          textDecoration: "underline",
                                          background: "transparent",
                                          border: "none",
                                          padding: 0,
                                          cursor: "pointer",
                                          font: "inherit",
                                        }}
                                      >
                                        View
                                      </button>
                                    )}
                                  </td>
                                  <td>{item[16]}</td>
                                  <td>{item[17]}</td>
                                  <td>{item[18]}</td>
                                  <td>{item[19]}</td>
                                  <td>{item[20]}</td>
                                  <td>{item[21]}</td>
                                  <td>{item[22]}</td>
                                  <td>{item[23]}</td>
                                  <td>{item[24]}</td>
                                  <td>{item[25]}</td>
                                  <td>{item[26]}</td>
                                  <td>{item[27]}</td>
                                  <td>{item[28]}</td>
                                  <td>{item[29]}</td>
                                  <td>{item[30]}</td>
                                  <td>{item[31]}</td>
                                  <td>{item[32]}</td>
                                  <td>{item[33]}</td>
                                  <td>{item[34]}</td>
                                  <td>{item[35]}</td>
                                  <td>{item[36]}</td>
                                  <td>{item[37]}</td>
                                  <td>{item[38]}</td>
                                  <td>{item[39]}</td>
                                  <td>{item[40]}</td>
                                  <td>{item[41]}</td>
                                  <td>{item[42]}</td>
                                  <td>{item[43]}</td>
                                  <td>
                                    {item[44] && (
                                      <button
                                        type="button"
                                        onClick={() => openImageModal(item[44])}
                                        style={{
                                          color: "#0d6efd",
                                          textDecoration: "underline",
                                          background: "transparent",
                                          border: "none",
                                          padding: 0,
                                          cursor: "pointer",
                                          font: "inherit",
                                        }}
                                      >
                                        View
                                      </button>
                                    )}
                                  </td>
                                  <td>{item[45]}</td>
                                  <td>{item[46]}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      )}
                    </table>
                    <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center' }}>
                      {totalPages > 1 && (
                        <ResponsivePagination
                          current={currentPage}
                          total={totalPages}
                          onPageChange={(page) => {
                            setCurrentPage(page);
                            getEnrollmentData(filterData, page);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <Footer />
        </div>
      </div>
      {/* --- SIDEBAR LAYOUT WRAPPER END --- */}

      {isModalOpen && selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            padding: "16px",
          }}
          onClick={closeImageModal}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "1100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={closeImageModal}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                zIndex: 10000,
                width: "42px",
                height: "42px",
                border: "none",
                borderRadius: "9999px",
                backgroundColor: "rgba(0, 0, 0, 0.75)",
                color: "#fff",
                fontSize: "26px",
                lineHeight: 1,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              aria-label="Close image preview"
            >
              X
            </button>
            <img
              src={selectedImage}
              alt="Aadhaar preview"
              style={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
                borderRadius: "10px",
                backgroundColor: "#fff",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}

